declare global {
  interface Array<T> {
    hasValue(this: string[]): boolean;
  }
}

Array.prototype.hasValue = function (this: string[]): boolean {
  if (!this) {
    return false;
  }

  if (this.length === 0) {
    return false;
  }

  // check for non-empty item
  if (!this.find((x) => x)) {
    return false;
  }

  return true;
};

export {};
